import { useEffect, useState } from "react";
import useDataStore from "../../../../../stores/dataStore";
import useMainStore from "../../../../../stores/mainStore";

function useNumberOpenedNotesInFolder(id?: string) {
    const Notes = useDataStore((state) => state.data?.notes);
    const openedNotesIDs = useMainStore((state) => state.data.openedNoteIDs);

    // State
    const [numOpenedNotesInFolder, setNumOpenedNotesInFolder] = useState(0);

    // Get the number of opened notes in the folder
    useEffect(() => {
        const getNoteIdsInFolders = openedNotesIDs.filter((noteID) => {
            return Notes[noteID]?.folderID === id;
        });

        setNumOpenedNotesInFolder(getNoteIdsInFolders.length);
    }, [openedNotesIDs, id, Notes]);

    return numOpenedNotesInFolder;
}

export default useNumberOpenedNotesInFolder;
